// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BASE_GUTTER_SPACE } from 'shared/styles/base';

export const Image = styled.img`
  display: inline-block;
  position: absolute;
  background: transparent;
  left: ${BASE_GUTTER_SPACE}px;
  top: ${BASE_GUTTER_SPACE}px;
`;
